export default {
    services: [],
    institutions_service: [],
    school_services: [],
    school_academic_periods: {}
  }
  